import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"

import "./information.vue?vue&type=style&index=0&id=e881a70e&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e881a70e"]])

export default __exports__